export const BASE = (process.env.REACT_APP_BASE_URL || "").replace(/\/+$/, "");
export const GALLERIES_DIR = (process.env.REACT_APP_GALLERIES_DIR || "/galleries").replace(/\/+$/, "");
// export const PHOTOS_DIR = (process.env.REACT_APP_PHOTOS_DIR || "/photos").replace(/\/+$/, "");
// export const THUMB_SIZE = process.env.REACT_APP_THUMB_SIZE || "384x384";
// export const FULL_SIZE  = process.env.REACT_APP_FULL_SIZE  || "2048x1152";

export function joinUrl(...parts: string[]) {
    return parts
        .filter(Boolean)
        .map((p, i) => (i === 0 ? p.replace(/\/+$/, "") : p.replace(/^\/+|\/+$/g, "")))
        .join("/");
}

// export function sizeUrl(filename: string, size: string) {
//     return joinUrl(BASE, PHOTOS_DIR, size, filename);
// }
